












































import {
    Component, Model, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component
export default class CustomDialog extends Vue {
    @Model('update:returnValue', { type: Boolean }) readonly value!: boolean;
    @Prop({ default: '' }) readonly headerTitle!: string;
    @Prop({ default: '520px' }) readonly maxWidth!: string | number;
    @Prop({ default: '500px' }) readonly contentHeight!: string | number;
    @Prop({ default: true }) readonly header!: boolean;
    @Prop({ default: true }) readonly headerDivider!: boolean;
    @Prop({ default: true }) readonly footerDivider!: boolean;
    @Prop({ default: false }) readonly subHeader!: boolean;
    @Prop({ default: false }) readonly persistent!: boolean;
    @Prop({ default: '10px' }) readonly borderRadius!: boolean;
    @Prop({ default: 'white' }) readonly color!: string;
    @Prop({ default: false }) readonly lazy!: boolean;

    // decided if close button will show up, default: true
    @Prop({ default: true }) readonly closeButton!: boolean;

    public cardClass: any = {};

    public created() {
        this.$set(this.cardClass, this.color, true);
    }

    public emitReturnValue(event: any) {
        this.$emit('update:returnValue', event);
    }
}
